import React from 'react';

import { HubeeListeContainer } from '@mairistem/administres-utils';
import { Dimmer } from '@mairistem/composants';

import { baseUrlApp } from '@/routes';
import { useHubeeStore } from '@/zustand';
import HubeeStatusMessage from '../HubeeStatusMessage';

const ListeHubee = () => {
  const hubeeStatus = useHubeeStore((state) => state.hubeeStatus);

  return (
    <div style={{ position: 'relative', height: '100%' }}>
      <HubeeListeContainer
        urlService="/api/administres/recensement-citoyen/hubee/teledossiers"
        urlDetail={`${baseUrlApp}hubee`}
        urlTraitement={`${baseUrlApp}recenses/assistant`}
        activated={!!hubeeStatus?.serialized && !!hubeeStatus?.liaisonActive}
      />
      {hubeeStatus &&
        (!hubeeStatus.serialized || !hubeeStatus.liaisonActive) && (
          <Dimmer active inverted>
            <div style={{ textAlign: 'center' }}>
              <HubeeStatusMessage
                serialized={hubeeStatus.serialized}
                liaisonActive={hubeeStatus.liaisonActive}
              />
            </div>
          </Dimmer>
        )}
    </div>
  );
};

export default ListeHubee;
